import {
  IAutoRenewalStatus,
  ISubscriptions,
} from '../../../subscriptions/types';
import { IApiAutoRenewal, IApiSubscription } from './subscription.types';

export const subscriptionSerializer = (
  apiSubscription: IApiSubscription
): ISubscriptions => {
  const isSub = !!apiSubscription.attributes.pass;

  const { pass } = apiSubscription.attributes;

  return {
    pass,
    isSub,
  };
};

export const autoRenewalSerializer = (
  apiAutoRenewal: IApiAutoRenewal
): IAutoRenewalStatus => {
  const isReactivable = apiAutoRenewal.attributes.auto_renewal.is_reactivable;
  const isCancellable = apiAutoRenewal.attributes.auto_renewal.is_cancellable;
  const isAutoRenewal =
    apiAutoRenewal.attributes.auto_renewal.status === 'activated';

  return { isCancellable, isAutoRenewal, isReactivable };
};
